import React from 'react';
import { Footer as SharedFooter, type AgencyContactInfo, type FooterLink } from '@insieme_dev/shared-ui-react';
import appConfig, { AGENCY_ID, REALIZATION_YEAR } from '../../config/appConfig';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

interface FooterProps {
  agencyData?: AgencyContactInfo;
}

const Footer: React.FC<FooterProps> = ({ agencyData }) => {
  const footerLinks: FooterLink[] = [
    { label: "Home", url: "/", title: "Torna alla homepage" },
    { label: "Immobili", url: "/immobili", title: "Cerca immobili" },
    { label: "Chi Sono", url: "/chi-sono", title: "Scopri chi sono" },
    { label: "Formazione", url: "/formazione", title: "I miei corsi di formazione" },
    { label: "Metodo di Lavoro", url: "/metodo-di-lavoro", title: "Il mio metodo di lavoro" },
    { label: "Contatti", url: "/contatti", title: "Contattami" },
  ];

  return (
    <SharedFooter
      agencyData={agencyData}
      config={{
        agency: {
          customPhone: appConfig.agency.customPhone || "",
          customPhone2: appConfig.agency.customPhone2 || "",
          customMobile: appConfig.agency.customMobile || "",
          customMobile2: appConfig.agency.customMobile2 || "",
          customAddress: appConfig.agency.customAddress || "",
        },
        ui: {
          footer: {
            showAddress: appConfig.ui.footer.showAddress,
            showTel1: appConfig.ui.footer.showTel1,
            showTel2: appConfig.ui.footer.showTel2,
            showMobile1: appConfig.ui.footer.showMobile1,
            showMobile2: appConfig.ui.footer.showMobile2,
            showExternalLink: appConfig.ui.footer.showExternalLink,
          }
        },
        copyright: {
          year: Number(REALIZATION_YEAR),
          companyName: "Insieme srl.",
          companyUrl: "https://www.gruppoinsieme.it"
        }
      }}
      links={footerLinks}
      className="chiara-crott-footer"
      aboutUsContent={undefined}
      apiConfig={!agencyData ? {
        apiBaseUrl: API_BASE_URL,
        agencyId: Number(AGENCY_ID)
      } : undefined}
      privacyLinks={{
        datiSocietari: "/dati",
        privacy: "/privacy",
        cookies: "/cookies"
      }}
      onBackToTop={() => {
        console.log('Back to top clicked - Chiara Crott');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
    />
  );
};

export default Footer;